import ListView from '~/models/listViews/listView';
import PublishedListView from '~/models/listViews/publishedListView';

export default {
  props: {
    listView: {
      type: Object as () => ListView | PublishedListView,
      required: true
    },
  },
  computed: {
    availableBulkActions() {
      if (this.isPreview) return this.listView.bulkActions;

      const objectModel = this.listView.published_object_model || this.listView.object_model;

      return this.listView.bulkActions.filter(action => {
        return this.$can('enable', action, { objectModel });
      });
    },
  },
}